// console.log('Cart drawer contents goes here');


class CartDrawer extends HTMLElement {
    constructor() {
        super();

        this.cartDrawerToggle = document.querySelector('.section-header-cart-drawer-toggle');
        this.cartDrawer = this;
        this.cartDrawerClose = this.querySelector('.cart-drawer-close');
        this.cartDrawerOverlay = this.querySelector('.cart-drawer-overlay');
        this.cartDrawerEmptyRedirect = this.querySelector('.cart-drawer-empty-footer');

        this.setAttribute('tabindex', '-1');

        if(this.cartDrawerToggle){
            this.cartDrawerToggle.addEventListener('click', (event) => this.onClick(event))
        }

        this.cartDrawerClose.addEventListener('click', () => this.close())
        this.cartDrawerClose.addEventListener('keyup', (event) => this.onCloseKeypress(event))
        this.cartDrawerOverlay.addEventListener('click', () => this.close())


        document.addEventListener('keyup', (event) => {
            if(event.key === 'Escape'){
                this.close();
            }
        })

        if( this.cartDrawerEmptyRedirect ){
            this.cartDrawerEmptyRedirect.addEventListener('click', () => this.close())
        }

        this.previousElement = this.cartDrawerToggle
    }

    onClick(event) {

        event.preventDefault();

        this.open()
    }

    onCloseKeypress(event){
        if (event.key === 'Enter') {

            this.close();
            
            // this.cartDrawerToggle.focus();

            // var quickviewElement = document.querySelector('.popup-modal-quickview:not(.inactive)');
            // if(quickviewElement){
            //     quickviewElement.querySelector('button[type="submit"]').focus();
            // }
        }
    }

    open() {
        this.previousElement = ( document.activeElement || this.cartDrawerToggle );

        this.cartDrawer.setAttribute('aria-hidden', 'false');
        this.cartDrawer.classList.add('active');

        setTimeout(() => {
            this.querySelector('a[href]').focus();
        }, 100)
    }
    close() {

        // this.cartDrawerToggle.focus();
        this.previousElement.focus();
            
        this.cartDrawer.setAttribute('aria-hidden', 'true');
        this.cartDrawer.classList.remove('active')

        var quickviewElement = document.querySelector('.popup-modal-quickview:not(.inactive)');
        if(quickviewElement){
            quickviewElement.querySelector('button[type="submit"]').focus();
        }
    }

}

customElements.define('cart-drawer', CartDrawer);

/* Weekend-delivery details modal — open/close + ESC + overlay click. */
(function () {
  function openModal(modal) {
    if (!modal) return;
    modal.hidden = false;
    document.body.classList.add('wdn-modal-open');
    var closeBtn = modal.querySelector('.wdn-modal__close');
    if (closeBtn) setTimeout(function () { try { closeBtn.focus(); } catch (e) {} }, 30);
  }
  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('wdn-modal-open');
  }
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest && e.target.closest('[data-wdn-open]');
    if (openBtn) {
      var wrapper = openBtn.closest('.wdn').parentNode || document;
      var modal = wrapper.querySelector('[data-wdn-modal]') || document.querySelector('[data-wdn-modal]');
      openModal(modal);
      return;
    }
    var closer = e.target.closest && e.target.closest('[data-wdn-close]');
    if (closer) {
      closeModal(closer.closest('[data-wdn-modal]'));
    }
  });
  document.addEventListener('keyup', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-wdn-modal]').forEach(function (m) {
      if (!m.hidden) closeModal(m);
    });
  });
})();